import React from 'react';
import { ArtistDrop } from './ArtistDrop';
import { LikedPlaylist } from './Liked/LikedPlaylist';
import { NewLikedReleases } from './Liked/LikedReleases';
import { PlaylistCreated } from './PlaylistCreated';
import { ReleaseCollectedByMany } from './ReleaseCollectedByMany';
import { ReleasesAddedToPlaylist } from './ReleasesAddedToPlaylist';
import { UserCollectedManySongs } from './UserCollectedManySongs';
import type { ActivityGroupWithDivider } from './store';

export const FeedActivityGroup = ({ item }: { item: ActivityGroupWithDivider }) => {
  const information = item.information;
  const timeStamp = item.latestActivityOccurenceAt;

  switch (information.__typename) {
    case 'SongCollectedByManyAggregate':
      return (
        <ReleaseCollectedByMany
          key={item.id}
          activityId={item.id}
          activityFrag={information}
          timeStamp={timeStamp}
        />
      );
    case 'ReleaseDroppedAggregate':
      return <ArtistDrop key={item.id} releaseFrag={information.release} timeStamp={timeStamp} />;
    case 'UserCollectedManySongsAggregate':
      return (
        <UserCollectedManySongs
          key={item.id}
          activityFrag={information}
          timeStamp={item.latestActivityOccurenceAt}
        />
      );

    case 'ShelfCreatedAggregate':
      return (
        <PlaylistCreated
          key={item.id}
          activityFrag={information}
          timeStamp={item.latestActivityOccurenceAt}
        />
      );

    case 'ReleasesAddedToShelfAggregate':
      return (
        <ReleasesAddedToPlaylist
          key={item.id}
          activityFrag={information}
          timeStamp={item.latestActivityOccurenceAt}
        />
      );

    case 'UserLikedSongsAggregate':
      return (
        <NewLikedReleases
          key={item.id}
          activityFrag={information}
          timeStamp={item.latestActivityOccurenceAt}
        />
      );

    case 'UserLikedPlaylistAggregate':
      return (
        <LikedPlaylist
          key={item.id}
          activityFrag={information}
          timeStamp={item.latestActivityOccurenceAt}
        />
      );

    default:
      return null;
  }
};
